// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__McUi3","selects":"Documents_selects__1K7yG"};